import { MasterStatusDescription } from './enums/master-status-id.enum';

// Chip colour names (from nha-chip) that a master status maps to. Shared so the status chip and
// the status dot always colour the same status the same way.
export type MasterStatusColor = 'yellow' | 'blue' | 'green' | 'gray' | 'clear';

// The single source of truth for enrollment-status colour. Keyed by master-status code
// (E, W, WL, …). Consumed by both nha-master-status-chip and nha-master-status-dot.
export function getMasterStatusColor(enrollmentStatusName: string): MasterStatusColor {
	switch (enrollmentStatusName) {
		case 'AP':
		case 'WL':
			return 'yellow';
		case 'AC':
			return 'blue';
		case 'E':
			return 'green';
		case 'W':
			return 'gray';
		default:
			return 'clear';
	}
}

const DESCRIPTION_TO_CODE: Record<string, string> = Object.entries(MasterStatusDescription).reduce<Record<string, string>>((map, [code, description]) => {
	map[description.toLowerCase()] = code;
	return map;
}, {});

// Reverse of MasterStatusDescription: resolves a full status string ("Enrolled") to its code
// ("E"), for callers whose data carries the description rather than the code/ID (e.g. search
// results). Returns null for an unrecognised status.
export function masterStatusCodeFromDescription(description: string): string | null {
	return DESCRIPTION_TO_CODE[(description ?? '').toLowerCase()] ?? null;
}
